import { render, staticRenderFns } from "./EipBoSelector.vue?vue&type=template&id=2fe5a8c0&scoped=true&"
import script from "./EipBoSelector.vue?vue&type=script&lang=js&"
export * from "./EipBoSelector.vue?vue&type=script&lang=js&"
import style0 from "./EipBoSelector.vue?vue&type=style&index=0&id=2fe5a8c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5a8c0",
  null
  
)

export default component.exports